import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

// Fixed categorical order (never cycled/reassigned) — "Other" always gets the last, neutral slot.
const COLORS = ['var(--series-1)', 'var(--series-2)', 'var(--series-3)', 'var(--series-4)', 'var(--series-5)', 'var(--muted)'];

const fmtUSD = (n) =>
  '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const ShareIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
    <path d="M22 12A10 10 0 0 0 12 2v10z" />
  </svg>
);

const ViewArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const BarsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

export default function AppShareDonut({ apps = [], loading = false, onViewAll }) {
  const sorted = [...apps].filter((a) => a.commission > 0).sort((a, b) => b.commission - a.commission);
  const top = sorted.slice(0, 5);
  const restTotal = sorted.slice(5).reduce((sum, a) => sum + a.commission, 0);
  const data = [...top, ...(restTotal > 0 ? [{ app_id: 'Other', commission: restTotal }] : [])];
  const total = data.reduce((sum, a) => sum + a.commission, 0);

  return (
    <div className="chart-section donut-section">
      <div className="chart-header">
        <div className="chart-title">
          <span className="chart-title-icon"><ShareIcon /></span>
          App Share
        </div>
        {onViewAll && data.length > 0 && (
          <button className="chart-view-all" onClick={onViewAll}>
            View All <ViewArrowIcon />
          </button>
        )}
      </div>

      {loading ? (
        <div className="donut-empty">Loading...</div>
      ) : data.length === 0 ? (
        <div className="donut-empty">No active apps in this period</div>
      ) : (
        <div className="donut-body">
          <div className="donut-plot">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  dataKey="commission"
                  nameKey="app_id"
                  innerRadius="66%"
                  outerRadius="100%"
                  paddingAngle={2}
                  stroke="none"
                >
                  {data.map((entry, i) => (
                    <Cell key={entry.app_id} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="donut-plot-total">
              <strong>{fmtUSD(total)}</strong>
              <span>Total</span>
            </div>
          </div>

          <div className="donut-legend">
            {data.map((entry, i) => (
              <div className="donut-legend-row" key={entry.app_id}>
                <span className="donut-legend-dot" style={{ background: COLORS[i % COLORS.length] }} />
                <span className="donut-legend-label">
                  {entry.app_id === 'Other' ? 'Other apps' : `App #${entry.app_id}`}
                </span>
                <span className="donut-legend-figures">
                  <span className="donut-legend-pct">
                    {total > 0 ? ((entry.commission / total) * 100).toFixed(1) : '0.0'}%
                  </span>
                  <span className="donut-legend-amount">{fmtUSD(entry.commission)}</span>
                </span>
              </div>
            ))}
          </div>

          {onViewAll && (
            <button className="donut-view-performance" onClick={onViewAll}>
              <BarsIcon /> View App Performance <ViewArrowIcon />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
